import React from 'react';
import { LocalTrackPublication, RemoteTrackPublication } from 'twilio-video';

import { useTrack } from 'hooks/session';
import AudioTrack from './AudioTrack';
import VideoTrack from './VideoTrack';

interface Props {
  publication: LocalTrackPublication | RemoteTrackPublication;
  isLocal?: boolean;
}

const Publication: React.FC<Props> = ({ publication, isLocal }: Props) => {
  const track = useTrack(publication);

  if (!track) return null;

  switch (track.kind) {
    case 'video':
      return <VideoTrack track={track} isLocal={isLocal} />;
    case 'audio':
      return <AudioTrack track={track} />;
    default:
      return null;
  }
};

export default Publication;
